import { render } from "./AppMonitor.vue?vue&type=template&id=00d27dde&scoped=true"
import script from "./AppMonitor.vue?vue&type=script&lang=js"
export * from "./AppMonitor.vue?vue&type=script&lang=js"

import "./AppMonitor.vue?vue&type=style&index=0&id=00d27dde&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d27dde"]])

export default __exports__